import { IconButton } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { IconButtonProps } from "@mui/material/IconButton/IconButton";

type Props = {
  changeEditMode: (disableEditMode: boolean) => void;
  resetFormDataOnClick: () => void;
  removeOpeningTimeFromParentStateAfterSave: () => void;
  saveOpeningTime: () => void;
  disableSaveIconButton: boolean;
};

export const ActionButtonsEditMode = ({
  changeEditMode,
  resetFormDataOnClick,
  removeOpeningTimeFromParentStateAfterSave,
  saveOpeningTime,
  disableSaveIconButton,
}: Props & IconButtonProps) => {
  return (
    <>
      {/* Save changes icon */}
      <IconButton
        type="button"
        key="save"
        onClick={(e) => {
          e.stopPropagation();
          changeEditMode(false);
          saveOpeningTime();
          removeOpeningTimeFromParentStateAfterSave();
        }}
        disabled={disableSaveIconButton}
      >
        <SaveIcon />
      </IconButton>

      {/* Leave edit mode icon */}
      <IconButton
        type="reset"
        key="reset"
        onClick={(e) => {
          e.stopPropagation();
          resetFormDataOnClick();
          changeEditMode(false);
        }}
      >
        <CloseIcon />
      </IconButton>
    </>
  );
};
